
/* ============================== src/components/Modals/TaskModal/TaskFooterActions.jsx ============================== */
// src/components/Modals/TaskModal/TaskFooterActions.jsx
import { Ic } from "../../Icons";
import { ICONS } from "../../iconsData";
import { TemplateActions } from "../../Templates/TemplateActions";
import { collectTaskPayloads } from "../../../utils/templateNesting";

/**
 * Левый блок футера карточки задачи.
 */
export function TaskFooterActions({
  readOnly,
  existing,
  canCreateFromTask,
  values,
  db,
  toast,
  onDelete,
  onCopy,
  disabled = false,
  onSaveAsDraft = null,
  saveAsDraftDisabled = false,
}) {
  const hasPersistedExisting = Boolean(existing?.id);
  const canDelete = Boolean(existing?.permissions?.canDelete);

  return (
    <>
      {!readOnly && hasPersistedExisting && canDelete && (
        <button className="btn danger" onClick={onDelete} disabled={disabled}>
          <Ic d={ICONS.trash} size={14} /> Удалить
        </button>
      )}

      {hasPersistedExisting && onCopy && canCreateFromTask && (
        <button
          type="button"
          className="btn ghost sm"
          onClick={() => onCopy(existing.id)}
          title="Создать новую задачу на основе этой"
          disabled={disabled}
        >
          <Ic d={ICONS.copy} size={13} /> Копировать
        </button>
      )}

      {canCreateFromTask && (
        <TemplateActions
          kind="task"
          source={values}
          nested={
            hasPersistedExisting
              ? collectTaskPayloads(db.tasks, existing.id)
              : []
          }
          toast={toast}
          disabled={disabled || !values.title?.trim()}
        />
      )}

      {onSaveAsDraft && (
        <button
          type="button"
          className="btn ghost sm"
          onClick={onSaveAsDraft}
          disabled={disabled || saveAsDraftDisabled}
          title="Сохранить как личный черновик"
        >
          <Ic d={ICONS.edit} size={13} /> В черновики
        </button>
      )}
    </>
  );
}
